module.exports = __webpack_public_path__ + "stormwater/connect/img/subsurface-storage.png";